import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {withRouter} from "react-router-dom";

import {BcaDeleteIcon} from "../../../../../images/BcaIcon";
import BcaIconButton from "../../../../../components/Buttons/BcaIconButton/BcaIconButton";
import ConfirmationDialog from "../../../../VirtualPortfolioManager/modals/ConfirmationDialog";
import {parseResponse, PortfolioHandlerResource} from "../../../../../utils/api";
import {displayErrorSnackBar, displaySuccessSnackBar} from "../../../../../components/SnackbarProvider/actions";
import {SERVER_ERROR} from "../../../../../utils/constants";

const MusterDepotDeleteBtn = (props) => {
  const {portfolioId, assetContainerId, portfolioName, onDelete, dispatch, className} = props;

  const [showPortfolioDeleteConfirmation, setShowPortfolioDeleteConfirmation] = React.useState(false);
  const [portfolioDeletingInProgress, setPortfolioDeletingInProgress] = React.useState(false);

  const handleOpenDeletingConfirmation = (event) => {
    event.stopPropagation();
    setShowPortfolioDeleteConfirmation(true);
  };

  const handleCloseDeletingConfirmation = (e) => {
    e && e.stopPropagation && e.stopPropagation();
    setShowPortfolioDeleteConfirmation(false)
  };

  const handleError = () => dispatch(displayErrorSnackBar(SERVER_ERROR));

  const deletePortfolio = (e) => {
    setPortfolioDeletingInProgress(true);

    // Note: we get customerID from url
    PortfolioHandlerResource.deletePortfolio(props.match.params.customer_id, portfolioId, assetContainerId)
      .then((response) => {
        parseResponse(response, 'portfolio',
          (data) => {
            if (data) {
              dispatch(displaySuccessSnackBar(<><b>{portfolioName}</b> wurde erfolgreich gelöscht.</>));
              handleCloseDeletingConfirmation(e);
              onDelete && onDelete();
            }
          }, handleError)
      })
      .catch(handleError)
      .finally(() => setPortfolioDeletingInProgress(false))
  };

  return (
    <div className={className}>
      <BcaIconButton
        tooltip={"Musterdepot aus Vermögensübersicht löschen"}
        icon={<BcaDeleteIcon />}
        onClick={handleOpenDeletingConfirmation}
      />
      <ConfirmationDialog
        message={'Sind Sie sicher, dass sie das Musterdepot aus der Vermögensübersicht löschen möchten?'}
        open={showPortfolioDeleteConfirmation || portfolioDeletingInProgress}
        onClose={handleCloseDeletingConfirmation}
        loading={portfolioDeletingInProgress}
        confirm={deletePortfolio}
      />
    </div>
  )
};

MusterDepotDeleteBtn.propTypes = {
  portfolioId: PropTypes.string.isRequired,
  portfolioName: PropTypes.string.isRequired,
};

export default withRouter(connect()(MusterDepotDeleteBtn));